export type PeekInsideSlide = {
  src: string
  alt: string
  caption: string
}

export const peekInsideSlides: PeekInsideSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nJu3EMR1hsWGoCq2HnXTKr/carousel-01-volume-map.png',
    alt: 'Volume 1 map page: a winding road from Block A to Block C beside a table of the ten intro sessions with level, lead scene icon and difficulty pips.',
    caption: "The map: from a stranger's first seat to 'when's the next one?'",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mALH6wh9SHxS31MNnByoDD/carousel-02-five-beats-loop.png',
    alt: 'The Paid Table Loop page: five gold wax seals in a circle labelled Seat, Spark, Play, Open Door and Rebook, each with its time window.',
    caption: 'The Paid Table Loop: five beats for every session.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nkCuvW68yLk9qJ345Y2AQg/carousel-03-pregen-characters.png',
    alt: 'Pre-gen page: five parchment character cards — Brute, Sneak, Guide, Scholar and Strider — each with a one-line motto and a turn tip.',
    caption: 'Five pre-gen concepts a first-timer picks up in two minutes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5aNNtiJzJew3kEPhznTbST/carousel-04-table-kit-goblin-market.png',
    alt: 'Table Kit 02, Goblin Market at Midnight: a 24 by 24 battle map, a d6 haggling table, ambush scaling by party size and two NPC cards.',
    caption: 'Table Kits: maps, NPCs, scaling and setup, ready to run.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sxwdb74LKae1Dz19X5y7sS/carousel-05-hobby-vs-paid-table.png',
    alt: 'Comparison page: hobby table versus paid table across the first 20 minutes — start, first action, rules, characters, tech, tone, eyes and names.',
    caption: 'Hobby table vs. paid table: the first 20 minutes decide the booking.',
  },
]
